import React, { useEffect, useState } from 'react';
import { makeApiRequest } from '../axiosService/apiCall';
import DataTable from 'react-data-table-component';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';

function UserWalletData() {

    const [data, setData] = useState([]);
    const [copiedValue, setCopiedValue] = useState('');
    const [searchQuery, setSearchQuery] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [balanceFilter, setBalanceFilter] = useState("all");

    const perPage = 5;

    // Fetching user data


    useEffect(() => {
        userData();
    }, []);

    const userData = async () => {
        try {
            setLoading(true);
            let params = {
                url: `getUserWallet`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log('response-----------', response)
            if (response.status) {
                setLoading(false);
                const userList = response?.userDetail;
                setData(userList);
            } else {
                setLoading(false);
                setData([]);
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    

    // const filteredData = data.filter((row) => {
    //     const email = row.userEmail ? row.userEmail.toLowerCase() : '';
    //     const coinAddress = row.coinaddress ? row.coinaddress.toLowerCase() : '';
    //     const privateKey = row.coinprivatekey ? row.coinprivatekey.toLowerCase() : '';

    //     const matchesSearch = (
    //         email.includes(searchQuery.toLowerCase()) ||
    //         coinAddress.includes(searchQuery.toLowerCase()) ||
    //         privateKey.includes(searchQuery.toLowerCase())
    //     );

    //     const texaBalance = parseFloat(row.Texa_balance || 0);
    //     const usdtBalance = parseFloat(row.BUSDT_balance || 0);

    //     let matchesBalance = true;
    //     if (balanceFilter === 'texa') {
    //         matchesBalance = texaBalance;
    //     } else if (balanceFilter === 'usdt') {
    //         matchesBalance = usdtBalance;
    //     }

    //     return matchesSearch && matchesBalance;
    // });



    const filteredData = data.filter(row => {

        const email = row.userEmail ? row.userEmail.toLowerCase() : '';
        const coinAddress = row.coinaddress ? row.coinaddress.toLowerCase() : '';
        const privateKey = row.coinprivatekey ? row.coinprivatekey.toLowerCase() : '';

        return (
            email.includes(searchQuery.toLowerCase()) ||
            coinAddress.includes(searchQuery.toLowerCase()) ||
            privateKey.includes(searchQuery.toLowerCase())
        );
    });

    const startIndex = (currentPage - 1) * perPage;
    const currentPageData = filteredData.slice(startIndex, startIndex + perPage);

    const compressString = (str) => {
        return str.length > 10 ? `${str.slice(0, 6)}...${str.slice(-4)}` : str;
    };

    const handleCopy = (value) => {
        setCopiedValue(value);
        setTimeout(() => setCopiedValue(''), 2000);
    };

    const columns = [
        { name: 'S.No', width: '100px', selector: (row) => row.sno },
        {
            name: 'Email',
            width: "350px",
            selector: (row) => row.userEmail,
            cell: (row) => <div className="no-wrap-cell">{row.userEmail}</div>,
        },
        {
            name: 'Address',
            width: '200px',
            selector: (row) => row.coinaddress,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.coinaddress)}
                    <CopyToClipboard className="ms-2" text={row.coinaddress} onCopy={() => handleCopy(row.coinaddress)}>
                        <FontAwesomeIcon icon={faCopy} />
                    </CopyToClipboard>
                </div>
            ),
        },
        {
            name: 'PrivateKey',
            width: '200px',
            selector: (row) => row.coinprivatekey,
            cell: (row) => (
                <div className="no-wrap-cell">
                    {compressString(row.coinprivatekey)}
                    <CopyToClipboard className="ms-2" text={row.coinprivatekey} onCopy={() => handleCopy(row.coinprivatekey)}>
                        <FontAwesomeIcon icon={faCopy} />
                    </CopyToClipboard>
                </div>
            ),
        },
        {
            name: 'USDT Balance',
            width: '250px',
            selector: (row) => row.BUSDT_balance > 0 ? row.BUSDT_balance.toFixed(2) : "-",
        },
        {
            name: 'Texa Balance',
            width: '250px',
            selector: (row) => row.Texa_balance > 0 ? row.Texa_balance.toFixed(2) : "-",
        },
    ];

    const formattedData = filteredData.map((row, index) => ({
        sno: index + 1,
        _id: row._id,
        userEmail: row.userEmail || "-",
        coinaddress: row.coinaddress || "-",
        coinprivatekey: row.coinprivatekey || "-",
        BUSDT_balance: Number(row.BUSDT_balance) || 0,
        Texa_balance: Number(row.Texa_balance) || 0
    }));

    return (

        <div className='App'>
            <div className='container'>
                <div className="custom-saled-order text-dark ms-3" style={{ marginLeft: "15px" }}>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <div className="py-3 d-flex align-items-center gap-3">
                                <h3 className="component-user mb-0">User Wallet</h3>
                                {loading ? (
                                    <button className='refresh-btn'>
                                        <div className="spinner-border" style={{ width: "20px", height: "20px" }} role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    </button>
                                ) : (
                                    <button className='refresh-btn fw-bold' onClick={userData}>
                                        Refresh
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>


                    <div className='row'>
                        <div className='col-lg-6'>
                            <input
                                className="form-control form-search"
                                type="text"
                                placeholder="Search Email or Address"
                                aria-label="default input example"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                            />
                        </div>
                        {/* <div className='col-lg-3'>
                            <select
                                className="form-select"
                                value={balanceFilter}
                                onChange={(e) => setBalanceFilter(e.target.value)}
                            >
                                <option value="all">All Balances</option>
                                <option value="texa">Texa Balance</option>
                                <option value="usdt">USDT Balance</option>
                            </select>
                        </div> */}
                    </div>
                    <br />
                    {copiedValue && <div className="alert alert-success">Copied: {copiedValue}</div>}
                    <div className='custom-datascroll'>
                        <DataTable
                            className="text-center"
                            columns={columns}
                            data={formattedData}
                            pagination
                            persistTableHead
                            // sortFunction={customSort}
                            paginationTotalRows={filteredData.length}
                            paginationPerPage={perPage}
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UserWalletData;